import { getStandardEmojiData } from './get-standard-emoji-data';
import { getAtlassianEmojiData } from './get-atlassian-emoji-data';

export const getEmojis = () => {
  const standardEmojis = getStandardEmojiData();
  const atlassianEmojis = getAtlassianEmojiData();

  const standardSprites = standardEmojis?.meta?.spriteSheets ?? {};
  const atlassianSprites = atlassianEmojis?.meta?.spriteSheets ?? {};

  return {
    emojis: [...standardEmojis.emojis, ...atlassianEmojis.emojis],
    meta: {
      spriteSheets: {
        ...standardSprites,
        ...atlassianSprites
      }
    }
  };
};
